import { Component, computed, input, output } from '@angular/core';

import { SelectItem } from '@shared/components/select/select-item.model';
import { SelectComponent } from '@shared/components/select/select.component';

@Component({
  selector: 'app-enum-cell-editor',
  standalone: true,
  imports: [SelectComponent],
  templateUrl: './enum-cell-editor.component.html'
})
export class EnumCellEditorComponent {
  value = input.required<unknown>();
  tableCellWidth = input<number>(0);
  enumValues = input<string[]>([]);
  enumLabels = input<string[] | undefined>(undefined);

  valueChange = output<string | null>();

  protected readonly enumItems = computed<SelectItem[]>(() => {
    const labels = this.enumLabels();
    return this.enumValues().map((value, index) => ({
      id: value,
      label: labels?.[index] ?? value
    }));
  });

  // When value() holds the label (e.g. "Copy 3"), look it up in enumLabels
  // to find the matching raw value (e.g. "copy:3") for the <select> pre-selection.
  protected selectedRawValue = computed<string>(() => {
    const current = this.value() as string;
    if (!current) return '';
    const labels = this.enumLabels();
    const values = this.enumValues();
    if (labels) {
      const idx = labels.indexOf(current);
      if (idx >= 0) return values[idx] ?? '';
    }
    return values.includes(current) ? current : '';
  });
}
